import { useTranslation } from 'react-i18next';
import { Grid } from '@shared/ui';

import { SectionHeader } from './SectionHeader';
import { DateRangePickerShowcase } from './forms/DateRangePickerShowcase';
import { FormExampleShowcase } from './forms/FormExampleShowcase';

export function FormsSection() {
  const { t } = useTranslation();

  return (
    <section id="forms" className="space-y-6">
      <SectionHeader
        title={t('uiLibrary.forms.title')}
        description={t('uiLibrary.forms.description')}
      />

      <Grid cols={1} gap="lg" className="lg:grid-cols-2">
        <div className="lg:col-span-2">
          <FormExampleShowcase />
        </div>
        <DateRangePickerShowcase />
      </Grid>
    </section>
  );
}
